/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {Pipe, PipeTransform} from '@angular/core';
import {L10nTranslationService} from 'angular-l10n';
import moment, {Moment} from "moment";
import {environment} from '../../../environments/environment';


declare type DateDetails = "short" | "long" | "detailed";

@Pipe({
    name: 'localizedDate',
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
    constructor(private translationService: L10nTranslationService) {
    }

    transform(value: any, format: DateDetails = "short"): string {
        let dateFormat = this.getFormat(format);
        return moment(value).format(dateFormat)
    }

    getFormat (format:DateDetails){
        const currentLanguage = this.translationService.getLocale();
        // Set the date format based on the current language
        let dateFormat: string;
        if (currentLanguage.language === 'de-DE') {
            if (format == "short") {
                dateFormat = environment.dateFormatShort;
            } else if (format == "long") {
                dateFormat = environment.dateFormat;
            } else {
                dateFormat = environment.dateFormatWithFractions;
            }
        } else {
            if (format == "short") {
                dateFormat = environment.dateFormatInternationalShort;
            } else if (format == "long") {
                dateFormat = environment.dateFormatInternational;
            } else {
                dateFormat = environment.dateFormatInternationalWithFractions;
            }
        }
        return dateFormat;
    }
}
